<template>
  <div id="checkCourierNumber">               
    <a-modal
      :maskClosable="false"
      :header="null"
      v-model="visible"
      :footer="null"
      width="70%"
    >

      <a-row style="margin-top: 50px" type="flex" justify="center">
         <a-col :span="6">
       
        </a-col>

           <a-col :span="12">
                    <label style="margin: 0 8px;font-size: 20px" >{{$t('publicLang.CourierNumber')}}: </label>
                    <a-input style="width: 300px;height: 35px;font-size: 20px" :placeholder="$t('publicLang.PleaseEnter')"  v-model.trim="courierNumber"
                     @pressEnter="courierNumberEnter"
                     size="small"/>
                     <label style="margin: 0 0px 0px 35px;font-size: 20px;color: red">{{count}}</label>
             </a-col>
      
        <a-col :span="6">
      
        </a-col>
      </a-row>

      <a-row style="margin-top: 30px;margin-bottom: 50px" type="flex" justify="center">
         <a-col :span="6"/>
           <a-col :span="12">
                    <label  :class="errFlag ? 'redStyle' : 'greenStyle'">{{errMsg}}</label>
             </a-col>
        <a-col :span="6"/>
      
      </a-row>

    </a-modal>
  </div>
</template>
<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
export default {
  data() {
    return {
      filterName: null,
      visible: false,
      errMsg:'    ',
      count: 0,
      courierNumber: null,
      errFlag: false
    };
  },
  methods: {

    courierNumberEnter(){
      if(this.courierNumber == null || this.courierNumber == ''  ){
              this.errFlag = true;
              this.errMsg =  this.$i18n.t('publicLang.CourierNumberIsNotNull')           
      }else{
        ajax.get(api.CHECKCOURIERNUMBER, {
          'courierNumber':this.courierNumber
        }) .then((res) => {    
          if(res.code != 200){
              this.errFlag = true;
          }else{
              this.errFlag = false;
              this.count = this.count + 1;
          }
              this.errMsg = res.msg      
        });

      }
    },
    //            表格数据
    init() {
         this.errMsg ='',
       this.count = 0,
       this.courierNumber = null
    },
    //            显示
    show() {
      this.visible = true;
      this.init();
    },
  },
};
</script>

<style lang="less">

.greenStyle{
  margin: 0 4px;
  font-size: 20px;
  color: green;
  height: 30px;
}
.redStyle{
  margin: 0 4px;
  font-size: 20px;
  color: red;
  height: 30px;
}






</style>
